import React from 'react';
import { TrendingUp, TrendingDown, Minus, Users, Calendar, CheckCircle2, Target } from 'lucide-react';

function MetricCard({ label, value, delta, icon: Icon, iconColor, isRTL }) {
  const trend = delta > 0 ? 'up' : delta < 0 ? 'down' : 'neutral';
  const trendColor = trend === 'up' ? '#10b981' : trend === 'down' ? '#ef4444' : '#94a3b8';
  const TrendIcon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus;

  return (
    <div style={{
      backgroundColor: 'var(--color-surface)',
      borderRadius: '10px',
      padding: '0.875rem 1rem',
      border: '1px solid var(--color-border)',
      display: 'flex', flexDirection: 'column', gap: '0.375rem',
      direction: isRTL ? 'rtl' : 'ltr',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.375rem' }}>
        <div style={{
          width: '28px', height: '28px', borderRadius: '6px',
          backgroundColor: `${iconColor}15`, display: 'flex',
          alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
          <Icon size={14} color={iconColor} style={{ flexShrink: 0, width: 14, height: 14 }} />
        </div>
        <span style={{ fontSize: '0.6875rem', color: 'var(--color-text-secondary)', fontWeight: 500 }}>{label}</span>
      </div>
      <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--color-text-primary)', lineHeight: 1.1 }}>
        {value}
      </div>
      {delta !== undefined && delta !== null && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', fontSize: '0.6875rem', color: trendColor, fontWeight: 500 }}>
          <TrendIcon size={12} style={{ flexShrink: 0, width: 12, height: 12 }} />
          <span>{delta >= 0 ? '+' : ''}{delta}</span>
        </div>
      )}
    </div>
  );
}

export default function ManagerGrowthMetrics({ growth = {}, isRTL, isMobile, t }) {
  if (!growth || Object.keys(growth).length === 0) return null;

  const cardStyle = {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '12px',
    padding: isMobile ? '1rem' : '1.25rem',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: '1px solid var(--color-border)',
    marginBottom: '1rem',
  };

  return (
    <div style={cardStyle}>
      <h3 style={{
        fontSize: '0.9375rem', fontWeight: 600,
        color: 'var(--color-text-primary)',
        marginBottom: '0.75rem',
        display: 'flex', alignItems: 'center', gap: '0.5rem',
      }}>
        <TrendingUp size={16} style={{ flexShrink: 0, width: 16, height: 16 }} />
        {t('managerDashboard.growthMetrics', 'Growth & Performance')}
      </h3>

      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
        gap: '0.625rem',
      }}>
        <MetricCard
          label={t('managerDashboard.newClientsMonth', 'New Clients (Month)')}
          value={growth.clientsThisMonth || 0}
          delta={growth.clientsDelta}
          icon={Users}
          iconColor="#3b82f6"
          isRTL={isRTL}
        />
        <MetricCard
          label={t('managerDashboard.weeklyMeetings', 'Weekly Meetings')}
          value={growth.meetingsThisWeek || 0}
          delta={growth.meetingsDelta}
          icon={Calendar}
          iconColor="#8b5cf6"
          isRTL={isRTL}
        />
        <MetricCard
          label={t('managerDashboard.totalClients', 'Total Clients')}
          value={growth.totalClients || 0}
          delta={null}
          icon={Target}
          iconColor="#f59e0b"
          isRTL={isRTL}
        />
        <MetricCard
          label={t('managerDashboard.completedTreatments', 'Completed Treatments')}
          value={growth.completedTreatments || 0}
          delta={null}
          icon={CheckCircle2}
          iconColor="#10b981"
          isRTL={isRTL}
        />
      </div>
    </div>
  );
}
